// extracted by mini-css-extract-plugin
module.exports = {"list":"ContentList_SP_list__2P43h"};